import React from 'react'
import { Link } from 'react-router-dom'
import { FiEdit3, FiPhone } from 'react-icons/fi'
import { FiFileText } from "react-icons/fi";
import PropTypes from 'prop-types';

EventSidebars.propTypes = {
    brochure_url: PropTypes.string,
    cta_url: PropTypes.string,
    phone_1: PropTypes.string,
    title: PropTypes.string,
    listing_type: PropTypes.string,
    slug: PropTypes.string,
};

export default function EventSidebars({ brochure_url = '', cta_url = '', phone_1 = '', title = '', listing_type = '', slug = '', listingid = '', price = '', price_discount = '', price_members = '', hasmembersprice = false, hasdiscount = false }) {

    if (cta_url === '/registro-evento') {
        cta_url = '/registro-evento/' + slug + '/' + listingid;
    }

    return (
        <>
            <div className="card bg-white p-4 rounded shadow sticky-bar">
                <div>
                    {cta_url && (
                        <div className='text-center'>
                            {(price !== null && price > 0) && (
                                <>
                                    <h6 className="text-center mb-2">
                                        <span className="text-success">${price}</span>
                                    </h6>
                                </>
                            )}
                            {(price !== null && parseInt(price) === 0) && (
                                <>
                                    <h6 className="text-center mb-2">
                                        <span className="text-success">Evento sin costo</span>
                                    </h6>
                                </>
                            )}
                            <Link to={cta_url} className="btn btn-success w-100 btn-sm mb-3 mx-auto text-center">
                                <FiEdit3 fontSize={'2em'} />
                                <span> Registro</span>
                            </Link>
                        </div>
                    )}
                    {phone_1 && (
                        <div className='text-center'>
                            <Link to={`tel:${phone_1}`} className="btn btn-secondary w-100 btn-sm mb-2 mx-auto text-center">
                                <FiPhone fontSize={'2em'} />
                                <span> Solicitar Información</span>
                            </Link>
                        </div>
                    )}
                    {brochure_url && (
                        <div className='text-center'>
                            <Link to={brochure_url} className="btn btn-primary w-100 btn-sm my-4 mt-1 mx-auto text-center">
                                <FiFileText fontSize={'2em'} />
                                <span> Descargar Folleto</span>
                            </Link>
                        </div>
                    )}
                    <br />
                </div>
            </div>
        </>
    )
}
